import React from "react";

const LpEmbassyHead = () => {
  return (
    <div className="lpEmbassyHead-container" id="verification-support">
      <div className="lpEmbassyHead-content">
        <h5>Verification</h5>
      </div>
      <h2>
        <span>Verification Done </span>in Just 3 Days
      </h2>
    </div>
  );
};

export default LpEmbassyHead;
